<template>
  <router-link :to="to" class="hover:bg-gray-100 rounded-lg shadow p-4 top-0 left-0" :id="toolId">
    <div class="container flex">
      <img class="h-10" :src="icon" alt="">
      <div>
        <h3 class="text-lg font-bold">{{ title }}</h3>
        <div class="text-gray-600">{{ description }}</div>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
defineProps({
  toolId: String,
  title: String,
  to: {
    type: String,
    required: true
  },
  icon: String,
  description: String
})
</script>
